import { useTranslation } from 'react-i18next'

import {
  QA_NAME_SHOW_LESS_BUTTON,
  QA_NAME_SHOW_MORE_BUTTON,
} from '../../../../../constants/qa'
import { useReadMore } from '../../../../../hooks'
import Button, { BUTTON_HEIGHT_24 } from '../../../../Button'
import Text from '../../../../Text'

import * as styles from './ApplicantReadMoreText.module.css'

function ApplicantReadMoreText({ isMuted, maxLines, qaName, text }) {
  const { t } = useTranslation()

  const { handleClickReadMore, isReadMore, showReadMore, textRef } =
    useReadMore({ maxLines, textData: text })

  return (
    <div className={styles.ApplicantReadMoreText}>
      <Text
        className={styles.text}
        disabled={isMuted}
        isSecondary={isMuted}
        qaName={qaName}
        ref={textRef}
      >
        {text}
      </Text>
      {showReadMore ? (
        <Button.Contained
          isGrey
          height={BUTTON_HEIGHT_24}
          qaName={
            isReadMore ? QA_NAME_SHOW_LESS_BUTTON : QA_NAME_SHOW_MORE_BUTTON
          }
          text={t(
            isReadMore
              ? 'Notification.CommonReadLessBtnKey'
              : 'Notification.CommonReadMoreBtnKey'
          )}
          onClick={handleClickReadMore}
        />
      ) : null}
    </div>
  )
}

export default ApplicantReadMoreText
